import * as React from "react";
export const PlusIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 11 11" fill="none" {...props}>
    <path d="M6.168.454H4.96v10h1.208v-10z" fill="#5EBE3F" />
    <path d="M10.395 4.83H.731v1.25h9.664V4.83z" fill="#5EBE3F" />
  </svg>
);
